import AxiosInstance from "./Axios";
import Cookies from "universal-cookie";

// POST /ib-report-full
//
// Request body:
// {
//   "tree_ids": [1000],
//   "ib_emails": ["hcarreno@tvmarkets.com"],
//   "transaction_type": ["DEPOSIT", "WITHDRAW", "PAYOUT"],
//   "from": 0,
//   "to": 1798761599
// }
//
// Response, same convention as /ib-report: { status, message, data: { reports: [...] } },
// where each report entry looks like:
// { date, ib_id, ib_email, name, deposit, withdraw, payout, wallet, currency, lastTxnDate, hierarchy_id }
const IBsFullReportRequest = async (params) => {
  try {
    const cookies = new Cookies();
    const token = cookies.get("token");

    const res = await AxiosInstance.post("/ib-report-full", params, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return res;
  } catch (error) {
    console.error("error in request:", error);
    throw error;
  }
};

export default IBsFullReportRequest;